<script setup>
import { OhVueIcon } from "oh-vue-icons";
import { store } from '../store.js'

const props = defineProps({
    linkToFullSurvey: {
        type: Boolean,
        default: false,
    },
});

const siteAnchor = document.querySelector('.header__title__text a')

let siteUrl = ''
if (siteAnchor) {
    siteUrl = siteAnchor.href;
}

scrollTo(0, 0);
</script>

<template>
    <div ref="targetRef" class="font-normal lg:text-xl mb-4">
        {{ store.translations.thanks_title }}
    </div>
    <div v-if="props.linkToFullSurvey">
        <a :href="`${siteUrl}/@@livingwage-survey#regionLevelOne=${store.regions.levelOne.id}&regionLevelTwo=${store.regions.levelTwo.id}`"
            class="inline-flex items-center justify-center px-5 py-3 text-base font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:ring-blue-300">
            <span>
                {{ store.translations.thanks_url_text }}
            </span>
            <span>
                <OhVueIcon name="hi-chevron-right" class="text-white" scale="1.5" />
            </span>
        </a>
    </div>
</template>
